import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import withDropdown from 'utils/withDropdown';
import StorageMartLanguageOption from '../StorageMartLanguageOption';
import Translation from '../../../../website/components/stateless/Translation';

const propTypes = {
  intl: intlShape.isRequired,
  languages: PropTypes.arrayOf(PropTypes.shape({
    locale: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
  })),
  onClick: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
};

const defaultProps = {
  languages: [],
  className: undefined,
};

const StorageMartLanguageMenu = React.forwardRef(({
  intl, languages, onClick, show, id, className,
}, ref) => {
  const { locale } = intl;
  const listContainer = 'bg-white pt-4 p-0 md:w-[160px] flex flex-col gap-2 md:p-2 md:border md:border-solid md:border-border md:top-8 md:z-30 md:absolute m-0';

  return (
    <div className={`relative ${className}`} ref={ref}>
      <button
        id={id}
        type="button"
        aria-haspopup
        onClick={onClick}
        aria-expanded={show}
        className="flex items-center w-full justify-between p-0"
      >
        <Translation id="sections.enterprise.storageMartHeader.languageSwitcher" defaultMessage="Language" />
        <svg
          className={`ml-1 w-4 md:w-2 block ${show ? 'rotate-180 ' : ''}`}
          viewBox="0 0 320 512"
          role="presentation"
          aria-hidden="true"
        >
          <path
            fill="currentColor"
            d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
          />
        </svg>
      </button>
      {show && (
        <ul
          className={listContainer}
          aria-labelledby={id}
        >
          {languages.map(language => (
            <StorageMartLanguageOption
              {...language}
              key={language.locale}
              active={locale === language.locale}
            />
          ))}
        </ul>
      )}
    </div>
  );
});

StorageMartLanguageMenu.propTypes = propTypes;
StorageMartLanguageMenu.defaultProps = defaultProps;

export default injectIntl(withDropdown(StorageMartLanguageMenu));
